import { render } from "./RegisterCompanies.vue?vue&type=template&id=27bae4cb"
import script from "./RegisterCompanies.vue?vue&type=script&lang=js"
export * from "./RegisterCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__